import useSWR from 'swr';
import { DGetSelfMedicationContact } from '../data/dtos/contact';
import { complaintChatService } from '../services/complaint';

export function useComplaintContact({
  userId,
}: Nullable<DGetSelfMedicationContact>) {
  const execute = async () => {
    return await complaintChatService.getUserContact({
      userId: userId!,
    });
  };

  const fetchKey = userId ? ['get-complaint-contact', userId] : null;
  const { mutate, data, isLoading, error } = useSWR(fetchKey, execute);

  return {
    mutate,
    data,
    error,
    isLoading,
  };
}
